module.exports = __webpack_public_path__ + "94039024813a01a5009496dad93ca86c.MP3";